import axios from '@/settings/axios'
import { apiSettings } from "@/settings/api"

let base = '/design/';
export default {
    get(page=1) {
        return axios.get(base + apiSettings.styles_ver + '/designs',{ params: {scope: '1', page: page}});
    }
}
